define((require) => {
    "use strict";

    const $             = require("jquery");
    const Effect        = require("shared/ui/experience/widgets/effects/Effect");
    const EffectModel   = require("shared/ui/experience/action/effects/EffectModel");
    const TweenMax      = require("TweenMax");
    const Preconditions = require("shared/util/Preconditions");

    return Effect.extend({

        reversible: false,

        config() {
            const modelValue = this.model.get("value");

            let scale;
            let duration;

            switch (modelValue) {
                case 1:
                    scale = 1.1;
                    duration = 1.0;
                    break;
                case 2:
                    scale = 1.2;
                    duration = 1.2;
                    break;
                case 3:
                    scale = 1.4;
                    duration = 1.0;
                    break;
                case 4:
                    scale = 1.6;
                    duration = 0.8;
                    break;
                case 5:
                    scale = 2;
                    duration = 0.6;
                    break;
                default:
                    // TODO Candidate for refactoring during MOS-2934.
                    Preconditions.warn(`DefaultSwitchWarn - Model scale '${modelValue}' not recognized.`);
                    break;
            }

            return {
                scale,
                duration,
                transformOrigin: "50% 50%"
            };
        },

        repeats() {
            return true;
        },

        finish() {
            // If we're finishing a hover effect, the default pausing behavior is not desired here.
            // We'll scale back to 1.0 and resetting (pause(0)) the underlying repeating pulse effect
            if (this.model.get("triggerType") === EffectModel.TRIGGER_TYPE_HOVER) {
                const duration = this.model.get("duration") / 1000;
                const element = this.element;

                return new $.Deferred((deferred) => {
                    this.pause();
                    TweenMax.to(element, duration, {
                        scale: 1.0,
                        onComplete: () => {
                            this.pause(0);
                            deferred.resolve();
                        }
                    });
                }).promise();
            }

            return Effect.prototype.finish.call(this);
        }

    });
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/widgets/effects/PulseEffect.js